// extracted by mini-css-extract-plugin
export default {"alarmContainer":"Alarm_alarmContainer__NIAx2","iconContainer":"Alarm_iconContainer__qBn22","content":"Alarm_content__iOPn4"};